import { all, call, put, takeLatest } from 'redux-saga/effects';
import queryApi from '../../utils/fetchApi';
import Urler from '../../utils/serviceUrl';
import { fetchTransactionsFailure, fetchTransactionsSuccess } from './transactions.actions';
import transactionActionTypes from './transactions.types';

export function* fetchTransactions({ payload: token }) {
    try {
        let res = yield queryApi({ method: 'GET', url: yield Urler('/transactions/me'), bearer: token });
        if (res.status === 'success') {
            yield put(fetchTransactionsSuccess(res.data.transactions));
        } else {
            yield put(fetchTransactionsFailure(res.message));
        }
    } catch (e) {
        yield put(fetchTransactionsFailure(e.message));
    }
}

export function* onFetchTransactionsStart() {
    yield takeLatest(transactionActionTypes.FETCH_TRANSACTIONS_START, fetchTransactions);
}

export function* transactionsSagas() {
    yield all([
        call(onFetchTransactionsStart)
    ]);
}
